



































import { Component, Vue, Prop } from "vue-property-decorator";
import ProjectUnitRow from "../estates/unit-row.vue";

@Component({
    components: {
        ProjectUnitRow
    }
})
export default class ProjectUnits extends Vue {
    @Prop() units!: any;

    sort: "bedrooms" | "type" | "number" | "floor" | "liveable_area_size" | "box" | "price" | "type_desc" | "number_desc" | "floor_desc" | "bedrooms_desc" | "liveable_area_size_desc" | "box_desc" | "price_desc" | null = null;

    mounted() {
        this.sortOn("box");
    }

    computedPrice(unit: any) {
        let prefix: string = "";
        let suffix: string = "";
        const price: string = `${unit.price.amount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        if (unit.price.currency === "EUR") {
            prefix = "€";
        }

        if (unit.negotiation === "sale") {
            return `${prefix} ${price} ${suffix}`;
        } else {
            return `${prefix} ${price} ${suffix} <span style="font-family:auto;">/</span> maand`;
        }
    }

    sortOn(value: "bedrooms" | "type" | "number" | "floor" | "liveable_area_size" | "box" | "price") {
        if (this.sort === value) {
            this.sort = `${value}_desc`;
        } else {
            this.sort = value;
        }
    }

    get sortedUnits() {
        return this.units.sort((a: any, b: any) => {
            if (this.sort === "number") {
                return a.box - b.box;
            } else if (this.sort === "number_desc") {
                return b.box - a.box;
            } else if (this.sort === "box") {
                return a.box.localeCompare(b.box);
            } else if (this.sort === "box_desc") {
                return b.box.localeCompare(a.box);
            } else if (this.sort === "type") {
                return a.type.localeCompare(b.type);
            } else if (this.sort === "type_desc") {
                return b.type.localeCompare(a.type);
            } else if (this.sort === "floor") {
                return a.floor - b.floor;
            } else if (this.sort === "floor_desc") {
                return b.floor - a.floor;
            } else if (this.sort === "liveable_area_size") {
                return a.sizes.liveable_area.size - b.sizes.liveable_area.size;
            } else if (this.sort === "liveable_area_size_desc") {
                return b.sizes.liveable_area.size - a.sizes.liveable_area.size;
            } else if (this.sort === "bedrooms") {
                return a.bedrooms - b.bedrooms;
            } else if (this.sort === "bedrooms_desc") {
                return b.bedrooms - a.bedrooms;
            } else if (this.sort === "price") {
                if (a.status === "sold" || a.status === "option") {
                    return 1;
                } else if (b.status === "sold" || b.status === "option") {
                    return -1;
                }
                return a.price.amount - b.price.amount;
            } else if (this.sort === "price_desc") {
                if (b.status === "sold" || b.status === "option") {
                    return 1;
                } else if (a.status === "sold" || a.status === "option") {
                    return -1;
                }
                return b.price.amount - a.price.amount;
            } else {
                return a.box - b.box;
            }
        });
    }
}
